import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/axios';
import { useAuth } from './AuthContext';

const PermissionsContext = createContext();

export const usePermissionsContext = () => useContext(PermissionsContext);

export const PermissionsProvider = ({ children }) => {
    const [permissions, setPermissions] = useState(null);
    const [loading, setLoading] = useState(true);
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        const fetchPermissions = async () => {
            if (isAuthenticated) {
                try {
                    setLoading(true);
                    const response = await apiClient.get('/permissions');
                    setPermissions(response.data);
                } catch (error) {
                    console.error("Failed to fetch permissions", error);
                    setPermissions({}); // Set empty permissions on error
                } finally {
                    setLoading(false);
                }
            } else {
                setPermissions(null);
                setLoading(false);
            }
        };

        fetchPermissions();
    }, [isAuthenticated]);

    const value = { permissions, loading };

    return (
        <PermissionsContext.Provider value={value}>
            {children}
        </PermissionsContext.Provider>
    );
};
